import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomModal from './BottomModal';
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import './style/Cart.css';
import { CartContext } from './CartContext';

const Cart = ({ isOpen, onClose }) => {
    const { cart, removeFromCart, updateQuantity, setCart } = useContext(CartContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const navigate = useNavigate();

    const increment = (id) => {
        const item = cart.find(item => item.id === id);
        updateQuantity(id, item.quantity + 1);
    };

    const decrement = (id) => {
        const item = cart.find(item => item.id === id);
        updateQuantity(id, item.quantity > 1 ? item.quantity - 1 : 1);
    };

    const openModal = (product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    };

    const handleButtonClick = () => {
        onClose();
        navigate('/DeliveryOrder');
    };

    const clearCart = () => {
        setCart([]);
    };

    return (
        <div className={isOpen ? "overlay-cart open" : "overlay-cart"} onClick={onClose}>
            <div className="modal-cart" onClick={e => e.stopPropagation()}>
                <div className="cart-basic-container">
                    <div className="cart-basic-header">
                        <div className="cart-header-top">
                            <div className="cart-header-title">
                                <div className="cart-header-zagolovok">
                                    <h1 className="cart-header-zagolovok-1">Корзина</h1>
                                </div>
                                <div className="cart-header-text">
                                    <span className="cart-header-text-1">Минимальный заказ от 1000 Т</span>
                                </div>
                            </div>
                            <div className="cart-header-close">
                                <button className="cart-header-close-1" onClick={onClose}><CloseIcon /></button>
                            </div>
                        </div>
                        <div className="cart-header-bottom">
                            <div className="cart-header-bottom-basic">
                                <div className="cart-header-bottom-price">
                                    <span className="cart-header-bottom-price-1">
                                        {cart.reduce((total, item) => total + (item.price * item.quantity), 0)} T
                                    </span>
                                </div>
                                <div className="cart-header-bottom-quantity">
                                    <span className="cart-header-bottom-quantity-1">
                                        Количество: {cart.reduce((total, item) => total + item.quantity, 0)}
                                    </span>
                                </div>
                            </div>
                            <div className="cart-header-bottom-trash-can">
                                <button className="cart-header-bottom-trash-can-1" onClick={clearCart}><DeleteForeverIcon /></button>
                            </div>
                        </div>
                    </div>
                    <div className="cart-basic-content">
                        {cart.map(item => (
                            <div key={item.id} className="cart-basic-tovar">
                                <div className="cart-basic-left">
                                    <div onClick={() => openModal(item)} style={{ cursor: 'pointer' }}>
                                        <div className="cart-basic-img">
                                            <img className="cart-basic-image" src={`${process.env.REACT_APP_IMAGES_URL}/${item.product_photo}`} alt={item.name} />
                                        </div>
                                    </div>
                                </div>
                                <div className="cart-basic-top">
                                    <div className="cart-basic-top-tovar-info">
                                        <span className="cart-basic-tovar-name">
                                            {item.name}
                                        </span>
                                    </div>
                                    <div className="cart-basic-top-1">
                                        <button onClick={() => decrement(item.id)} className="cart-basic-top-1-2">-</button>
                                        <span className="cart-basic-top-1-3">{item.quantity} шт</span>
                                        <button onClick={() => increment(item.id)} className="cart-basic-top-1-2">+</button>
                                    </div>
                                </div>
                                <div className="cart-basic-right">
                                    <div className="cart-basic-right-delete">
                                        <button className="cart-basic-right-delete" onClick={() => removeFromCart(item.id)}><CloseIcon /></button>
                                    </div>
                                    <div className="cart-basic-right-price">
                                        <span className="cart-basic-right-price-1">
                                            {item.price} T
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="cart-basic-result">
                        <div className="cart-basic-result-text">
                            <div className="cart-basic-result-text-1">
                                <span className="cart-basic-result-text-1-1">
                                    Итог без скидки
                                </span>
                            </div>
                            <div className="cart-basic-result-text-1">
                                <span className="cart-basic-result-text-1-1">
                                    Вы сэкономили
                                </span>
                            </div>
                        </div>
                        <div className="cart-basic-result-numbers">
                            <div className="cart-basic-result-numbers-1">
                                <span className="cart-basic-result-numbers-1-1">
                                    {cart.reduce((total, item) => total + (item.price * item.quantity), 0)} T
                                </span>
                            </div>
                            <div className="cart-basic-result-numbers-1">
                                <span className="cart-basic-result-numbers1-1">
                                    0,00 T
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="cart-basic-checkout">
                        <button className="cart-basic-checkout-knopka" onClick={handleButtonClick}>
                            <div className="cart-basic-checkout-left-text">
                                <span className="cart-basic-checkout-left-text-1">{cart.reduce((total, item) => total + (item.price * item.quantity), 0)}T</span>
                            </div>
                            <div className="cart-basic-checkout-right-text">
                                <span className="cart-basic-checkout-right-text-1">Оформить заказ</span>
                            </div>
                        </button>
                    </div>
                </div>
                <BottomModal isOpen={isModalOpen} onClose={closeModal} product={selectedProduct} />
            </div>
        </div>
    );
};

export default Cart;
